export default function HTTP() {
    return <div className=" max-w-4xl w-full p-8 h-full shadow-lg rounded-xl border
     border-gray-200 mx-auto xl:ml-64 min-h-screen text-center"> 
      HTTP.... </div>;
  }
  